import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Components
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Summaries from "./pages/Summaries";
import Locations from "./pages/Locations";
import Navigation from "./components/Navigation";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/receipts"
          element={
            <ProtectedRoute>
              <>
                <Navigation />
                <Container fluid className="mt-4">
                  <Summaries />
                </Container>
              </>
            </ProtectedRoute>
          }
        />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route
          path="/locations"
          element={
            <ProtectedRoute>
              <>
                <Navigation />
                <Container fluid className="mt-4">
                  <Locations />
                </Container>
              </>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/receipts" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
